import React from 'react';
import { motion } from 'framer-motion';
import ProjectCard from './ProjectCard';
import projectsData from '../data/projects.json';

const Projects = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.5 }}
      className="mb-16"
    >
      <h2 className="section-heading">Projects</h2>
      <div className="max-w-3xl mx-auto">
        <p className="text-muted-foreground text-lg mb-8 text-center">
          {projectsData.intro}
        </p>
      </div>
      <div className="grid md:grid-cols-2 gap-8">
        {projectsData.projects.map((project, index) => (
          <ProjectCard key={index} {...project} />
        ))}
      </div>
    </motion.section>
  );
};

export default Projects;
